import { useEffect, useRef, useState } from "react";
import { AutoComplete, message } from "antd";

import "./CrrDropDownWithExtApiStyles.scss";
import LocationIcon from "../../../assets/images/location-icon.svg";
import axios from "axios";
import { showError } from "../../../helpers/Notifications/Notification";

export default function CrrDropDownWithExtApi(props) {
  const {
    qnId, // to check if the page using the component is pre-assessment
    multi_resp,
    selectField,
    placeholderText,
    onChange,
    setValue,
    options_link,
    form,
    answer,
    value,
    setselectField,
  } = props;

  const [searchText, setSearchText] = useState("");
  const [optionsList, setOptionsList] = useState([]);
  let timer = useRef(null);

  const fetchOptions = async (optionsLink, search) => {
    let response;
    try {
      // api call
      response = await axios({
        method: optionsLink?.method,
        url: process.env.REACT_APP_API_BASEURL + optionsLink?.base_url,
        params: { ...optionsLink.params, search },
      });

      if (response?.status) {
        setOptionsList(response?.data?.data);
      } else {
        message.destroy();
        showError("Could not fetch options");
      }
    } catch (error) {
      message.destroy();
      showError("Could not fetch options");
    }
  };

  useEffect(() => {
    //call api with searched text
    if (searchText.length > 2) {
      fetchOptions(options_link, searchText);
    }
  }, [searchText]);

  useEffect(() => {
    const ans = multi_resp
      ? answer.map((answer) => answer.text_answer)
      : answer?.text_answer;
    // populating value according to answer
    if (qnId) {
      form.setFieldsValue({
        [qnId]: ans,
      });
      setValue(ans);
    }
  }, [answer]);

  const formatAnswer = (ans) => {
    if (multi_resp) {
      return ans ? ans.map((ans) => ans) : [];
    } else {
      return ans ? ans : null;
    }
  };

  const handleSearch = (input) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      setSearchText(input);
    }, 300);
  };

  const handleOnBlur = () => {
    if (onChange && value) {
      if (qnId) {
        onChange({
          question_id: qnId,
          text_answer: formatAnswer(form.getFieldValue(qnId)),
        });
      } else {
        onChange(value);
      }
    }
  };

  const onHandleChange = (selectedValue) => {
    form.setFieldsValue({
      [qnId]: selectedValue,
    });
    setValue(selectedValue);
  };

  return (
    <>
      <AutoComplete
        className="login-input auto-complete"
        mode={multi_resp ? "multiple" : ""}
        value={qnId ? form.getFieldValue(qnId) : value}
        onSearch={handleSearch}
        placeholder={!selectField && placeholderText}
        onChange={onHandleChange}
        bordered={false}
        onBlur={handleOnBlur}
        onFocus={() => setselectField(true)}
      >
        {optionsList.map((op, i) => (
          <AutoComplete.Option key={i} value={op.value || op.name || op.option}>
            {options_link?.params?.type === "city" ? (
              <img
                alt="location-icon"
                src={LocationIcon}
                className="dropdown-icon"
              />
            ) : (
              ""
            )}
            {op.option}
          </AutoComplete.Option>
        ))}
      </AutoComplete>
    </>
  );
}
